import { graphql } from 'relay-runtime'
import { FC } from 'react'
import { useFragment } from 'react-relay/hooks'
import { PostSeoHead_post$key } from './__generated__/PostSeoHead_post.graphql'
import { NextSeo } from 'next-seo'
import { usePostSeoHead } from './dependencies'

interface PostSeoHeadProps {
  post: PostSeoHead_post$key | null
  page?: number
}

export const PostSeoHead: FC<PostSeoHeadProps> = ({ post, page = 1 }) => {
  const data = useFragment(fragment, post)
  const nextSeoProps = usePostSeoHead(data, page)

  return <NextSeo {...nextSeoProps} />
}

const fragment = graphql`
  fragment PostSeoHead_post on Post {
    h1
    slug
    image {
      url
    }
    meta_description
    meta_keywords
    meta_robots
  }
`
